import Hero from './components/Hero';
import HomeIntro from './components/HomeIntro';
import HomeSolutions from './components/HomeSolutions';
import HomeCta from './components/HomeCta';

export default function Home() {
  return (
    <>
      <Hero />
      <HomeIntro />
      <HomeSolutions />
      <HomeCta />
    </>
  );
}